import { render, staticRenderFns } from "./ActiveOrders.vue?vue&type=template&id=70090f48&scoped=true&"
import script from "./ActiveOrders.vue?vue&type=script&lang=js&"
export * from "./ActiveOrders.vue?vue&type=script&lang=js&"
import style0 from "./ActiveOrders.vue?vue&type=style&index=0&id=70090f48&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70090f48",
  null
  
)

export default component.exports